/**
 * Created by Christof Sander on 07.12.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'trees',
		'tree'
	],

	config: {
		treeConfig: {
			plugins: [
				'types',
				'dnd',
				'search'
			],
			core: {
				check_callback: function(operation, node, node_parent, node_position, more) {
					var result = false;
					if(operation === 'move_node'){
						result = node.type === 'scopeRole' && node_parent && node_parent.type === 'scope' && node.parent != node_parent.id;
					}
					return result;
				}
			},
			// plugins: [
			// 'contextmenu', 'dnd', 'search',
			// 'state', 'types', 'wholerow'
			// 'state',
			// 'types',
			// 'checkbox'
			// 'contextmenu',
			// 'dnd'
			// ]
		}
	}
};
